import React from 'react';
import { navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { compose } from '@/utils/story-composer';
import LinkComponent from '@/components/elements/link-component';
import { enUs, CountriesEnum } from '@/enums/countries';
import { formatUrl, LibraryPages, getLibraryUrlPrefix } from '@/utils/url';
import Dropdown from '@/components/elements/dropdown';
import IconText from '@/components/elements/icon-text';

function Footer({ elementProps, columns, socialButtons, bottomLinks, pageContext }) {
	const { localizations, isLibrary } = pageContext;
	const { t, i18n } = useTranslation();

	const countries = [...CountriesEnum];
	if (isLibrary) {
		countries.splice(
			countries.findIndex(c => c.locale === 'en'),
			0,
			enUs
		);
	}

	const currentLanguage = i18n.language;
	const selectedItem =
		countries.find(country => country.locale === currentLanguage) ||
		countries.find(country => country.locale === 'en') ||
		countries[0];

	const countryChanged = country => {
		const locale = localizations?.find(c => c.locale === country.locale);

		// The library doesn't support nl yet
		if (isLibrary) {
			i18n.changeLanguage(country.locale);
			navigate(`/${getLibraryUrlPrefix(country.locale, t, LibraryPages.LANDING)}`);
		} else if (locale) {
			navigate(formatUrl(locale.full_slug));
		} else {
			// Redirect to home when there is no related translatable page
			navigate(`/${country.locale}`);
		}
	};

	return (
		<footer {...elementProps}>
			<div className="bg-mariner">
				<div className="container">
					<div className="grid grid-cols-1 md:grid-cols-[repeat(4,_minmax(0,max-content))] lg:grid-cols-[repeat(5,_minmax(0,max-content))] pt-10 pb-6 md:pb-10 md:border-t gap-x-16 lg:pb-0 border-white">
						{columns}
					</div>
					<div className="flex pb-6 md:pb-10 justify-center lg:justify-end">
						{socialButtons &&
							socialButtons.map(link => (
								<LinkComponent key={link._uid} {...link} appearance="mr-2">
									<IconText icon={link.icon} height="28px" width="28px" />
								</LinkComponent>
							))}
					</div>
				</div>
			</div>
			<div className="flex flex-1 flex-col lg:flex-row bg-white container my-5 lg:justify-between">
				<div className="flex flex-col md:flex-row justify-between lg:order-2">
					{bottomLinks &&
						bottomLinks.map(link => (
							<LinkComponent key={link._uid} {...link} appearance="text-mariner mb-3 md:mb-0 lg:px-3">
								{link.text && link.text}
							</LinkComponent>
						))}
				</div>
				<div className="flex flex-1 flex-row mt-5 lg:mt-0 lg:order-1">
					<span className="italic">Copyright ® 2009 -{new Date().getFullYear()} Gynzy</span>
				</div>
				<div className="flex flex-1 order-3 justify-start md:justify-end mt-5 md:mt-0">
					<div className="w-56">
						<Dropdown items={countries} selectedItem={selectedItem} setSelected={country => countryChanged(country)} />
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;

compose('footer', Footer, { children: ['columns'] });
